const icons = {
  mdb: 'access',
  accdb: 'access',
  ai: 'ai',
  html: 'html',
  htm: 'html',
  asp: 'web',
  pdf: 'pdf',
  psd: 'photoshop',
  psb: 'photoshop',
  mpo: 'photoshop',
  eps: 'photoshop',
  avi: 'video',
  wmv: 'video',
  rm: 'video',
  rmvb: 'video',
  mp4: 'video',
  '3gp': 'video',
  asf: 'video',
  mov: 'video',
  m4v: 'video',
  flv: 'video',
  f4v: 'video',
  mkv: 'video',
  mts: 'video',
  swf: 'flash',
  ts: 'video',
  mp3: 'audio',
  wav: 'audio',
  wma: 'audio',
  ape: 'audio',
  aac: 'audio',
  zip: 'zip',
  rar: 'zip',
  gz: 'zip',
  '7z': 'zip',
  z: 'zip',
  bmp: 'image',
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  webp: 'image',
  svg: 'image',
  txt: 'txt',
  rtf: 'txt',
  xls: 'excel',
  xlsx: 'excel',
  xlsm: 'excel',
  xltx: 'excel',
  doc: 'word',
  docx: 'word',
  docm: 'word',
  wps: 'word',
  dotx: 'word',
  dotm: 'word',
  ppt: 'powerpoint',
  pptx: 'powerpoint',
  mdf: 'db',
  db: 'db',
  dbf: 'db',
  wdb: 'db',
  vue: 'vue',
  php: 'php',
  jar: 'jar',
  ini: 'ini',
  bat: 'bat',
  config: 'config',
  fla: 'fla',
  eot: 'font',
  otf: 'font',
  fon: 'font',
  font: 'font',
  ttf: 'font',
  ttc: 'font',
  woff: 'font',
  woff2: 'font',
  js: 'js',
  md: 'markdown',
  one: 'onenote',
  jsx: 'reactjs',
  xfl: 'xfl',
  file: 'file',
  css: 'css'
}

Object.keys(icons).forEach(item => {
  icons[item] = require('./images/' + icons[item] + '.svg')
})

export default icons
